import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchedStations, fetchStations } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchStations>;

function* getStationsSaga({ meta: { callback } }: FetchActionPayload) {
  const { getPublicStations } = getAPI();
  const response: YieldOf<typeof getPublicStations> = yield call(getPublicStations);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedStations(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedStations(undefined, error));
  }

  if (callback) callback();
}

export default function* stationsSaga() {
  yield takeLatest(fetchStations.type, getStationsSaga);
}
